import React from 'react';

import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { HighlightTitle } from '@zola/zola-ui/src/components/PreAuthV3';

import { Wrapper } from './GridTextItem.styles';

type GridTextItemProps = {
  hed: JSX.Element;
  dek?: string;
  cta: {
    text: string;
    href: string;
  };
};

const GridTextItem = (props: GridTextItemProps) => {
  const { hed, dek, cta } = props;

  return (
    <Wrapper>
      <HighlightTitle isH1={false}> {hed} </HighlightTitle>
      {dek && <p> {dek} </p>}
      <ButtonV3 component="a" href={cta.href}>
        {cta.text}
      </ButtonV3>
    </Wrapper>
  );
};

export default GridTextItem;
